module.exports = __webpack_public_path__ + "img/featured-panel.5ac2c49a.svg";